<template>
  <div>
    <Head title="Grates" />
    <div class="flex items-center mb-8">
      <h1 class="text-3xl font-bold">Grates</h1>
      <span class="text-xs mx-2 rounded-full p-2 bg-gray-200"> {{ grates.total }}</span>
    </div>

    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Deleted:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null">Exclude Deleted</option>
          <option value="with">Include Deleted</option>
          <option value="only">Only Deleted</option>
        </select>
      </search-filter>
      <div class="flex gap-4">
        <a href="/grates/export" target="_blank" class="border border-gray-600 text-gray-600 flex items-center px-4 hover:bg-gray-600 hover:text-white" download>Export</a>
        <Link class="btn-blue" href="/grates/create">
          <span>Create</span>
          <span class="hidden md:inline">&nbsp;Grate</span>
        </Link>
      </div>
    </div>
    <div class="bg-white  shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Part number</th>
            <th class="pb-4 pt-6 px-6">Class</th>
            <th class="pb-4 pt-6 px-6">Material</th>
            <th class="pb-4 pt-6 px-6">Design</th>
            <th class="pb-4 pt-6 px-6">Length</th>
            <th class="pb-4 pt-6 px-6">Compliances</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="grate in grates.data" :key="grate.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/grates/${grate.id}/edit`" tabindex="-1">
                {{ grate.part_number }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/grates/${grate.id}/edit`">
                {{ grate.class }}
                <icon v-if="grate.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/grates/${grate.id}/edit`">
                {{ grate.material }}
                <icon v-if="grate.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-blue-500" :href="`/grates/${grate.id}/edit`">
                {{ grate.design }}
                <icon v-if="grate.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/grates/${grate.id}/edit`" tabindex="-1">
                {{ grate.length }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-6 py-4" :href="`/grates/${grate.id}/edit`" tabindex="-1">
                <div v-for="c in grate.compliances" :key="c.id" class="border rounded-md py-1 border-blue-400  flex items-center mx-0.5" :alt="c.name">
                  <compliance-icon :name="c.icon" class="flex-shrink-0 mx-1 w-4 h-4 fill-blue-800" />
                </div>
              </Link>
            </td>
            <td class="w-px border-t">
              <div class="flex">
                <Link class="flex items-center px-2" :href="`/grates/${grate.id}/edit`" tabindex="-1">
                  <icon name="edit" class="block w-4 h-4 fill-gray-400" />
                </Link>
              </div>
            </td>
          </tr>
          <tr v-if="grates.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No grates found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="grates.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import ComplianceIcon from '@/Shared/CompliancesIcon'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    ComplianceIcon,
  },
  layout: Layout,
  props: {
    filters: Object,
    grates: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/grates', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
